import { render, staticRenderFns } from "./DockedPlayer.vue?vue&type=template&id=16d251cb&scoped=true"
import script from "./DockedPlayer.vue?vue&type=script&lang=js"
export * from "./DockedPlayer.vue?vue&type=script&lang=js"
import style0 from "./DockedPlayer.vue?vue&type=style&index=0&id=16d251cb&prod&scoped=true&lang=css"
import style1 from "./DockedPlayer.vue?vue&type=style&index=1&id=16d251cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d251cb",
  null
  
)

export default component.exports